export default __webpack_public_path__ + "public/media/qr-code-windows.4af0068d.webp";